<!-- Overlay -->
<div class="ala-overlay" [class.open]="isOpen" (click)="close()"></div>

<!-- Drawer -->
<div class="ala-drawer" [class.open]="isOpen">

  <!-- Header -->
  <div class="ala-header">
    <div class="ala-header-icon"><i class="fas fa-magic"></i></div>
    <div class="ala-header-title">
      <h2>{{ employeeName }}</h2>
      <p>{{ subtitle }}</p>
    </div>
    <div class="ala-header-amount">
      <div class="ala-amount-label">{{ amountLabel }}</div>
      <div class="ala-amount-val">{{ formatCurrency(amount) }}</div>
    </div>
    <button class="ala-close-btn" (click)="close()"><i class="fas fa-times"></i></button>
  </div>

  <!-- TEMP: Summary Pills hidden
  <div class="ala-summary-bar" *ngIf="!isLoading && !hasError && response">
    <div class="ala-pill green">
      <div class="ala-pill-label">Total Credited</div>
      <div class="ala-pill-value">{{ formatCurrency(totalCredited) }}</div>
    </div>
    <div class="ala-pill">
      <div class="ala-pill-label">Total Loaded to Card</div>
      <div class="ala-pill-value">{{ formatCurrency(totalLoadedToCard) }}</div>
    </div>
    <div class="ala-pill red" *ngIf="hasReversals">
      <div class="ala-pill-label">Reversals</div>
      <div class="ala-pill-value">-{{ formatCurrency(reversals) }}</div>
    </div>
    <div class="ala-pill">
      <div class="ala-pill-label">Card Loads</div>
      <div class="ala-pill-value">{{ cardLoadCount }}</div>
    </div>
    <div class="ala-pill">
      <div class="ala-pill-label">Ledger Events</div>
      <div class="ala-pill-value">{{ ledgerEventCount }}</div>
    </div>
  </div>
  -->

  <!-- Loading State -->
  <div class="ala-body" *ngIf="isLoading" style="align-items:center;justify-content:center;">
    <p-progressSpinner [style]="{width:'60px',height:'60px'}" strokeWidth="3"></p-progressSpinner>
    <p style="color:#888;margin-top:16px;font-size:13px;">Analyzing ledger data...</p>
  </div>

  <!-- Error State -->
  <div class="ala-body" *ngIf="hasError && !isLoading" style="align-items:center;justify-content:center;">
    <i class="fas fa-exclamation-triangle" style="font-size:32px;color:#cc0000;"></i>
    <p style="color:#cc0000;margin-top:12px;font-size:13px;">{{ errorMessage }}</p>
  </div>

  <!-- Content -->
  <div class="ala-body" *ngIf="!isLoading && !hasError && response">

    <!-- Narrative Pane -->
    <div class="ala-narrative-pane" (click)="onNarrativeClick($event)">
      <div class="ala-ai-card">
        <div class="ala-ai-header">
          <i class="fas fa-magic"></i> AI LEDGER ANALYSIS
          <span class="ala-ai-badge">&#10022; AI Generated</span>
        </div>
        <div class="ala-ai-body" [innerHTML]="answerHtml"></div>
      </div>

      <!-- Star Rating -->
      <div style="display:flex;align-items:center;gap:8px;margin-top:14px;">
        <span style="font-size:11px;color:#888;font-weight:600;">Rate this analysis:</span>
        <span *ngFor="let s of [1,2,3,4,5]"
              (click)="setStars(s)"
              style="cursor:pointer;font-size:18px;"
              [style.color]="s <= stars ? '#f5a623' : '#ddd'">&#9733;</span>
      </div>
    </div>

    <!-- Ledger Pane -->
    <div class="ala-ledger-pane" [class.expanded]="isTimelineExpanded" #ledgerPane>
      <div class="ala-timeline-card">
        <div class="ala-timeline-header" (click)="toggleTimeline()" style="cursor:pointer;user-select:none;">
          <i class="fas fa-list-ul"></i> LEDGER TIMELINE — {{ ledgerEventCount }} EVENTS
          <span style="margin-left:auto;font-size:11px;font-weight:400;opacity:0.7;">{{ timelineToggleLabel }}</span>
          <i class="fas fa-chevron-down"
             [style.transform]="isTimelineExpanded ? 'rotate(180deg)' : ''"
             style="margin-left:8px;transition:transform 0.2s;"></i>
        </div>
        <div class="ala-tbl-wrap" [style.display]="isTimelineExpanded ? 'block' : 'none'" #tblWrap>
          <table class="ala-tbl">
            <thead>
              <tr>
                <th class="num" style="width:34px">#</th>
                <th style="width:96px">Date</th>
                <th style="width:128px">Timestamp</th>
                <th style="width:140px">Action</th>
                <th style="width:140px">Actor</th>
                <th style="width:72px">Shift</th>
                <th style="width:72px">Job</th>
                <th class="num" style="width:80px">Credit</th>
                <th class="num" style="width:80px">Debit</th>
                <th>Summary</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let event of response.Timeline; let i = index"
                  [class]="getRowClass(event, i)"
                  [id]="'ala-row-' + event.RowNo">
                <td class="num ala-row-num">{{ event.RowNo }}</td>
                <td>{{ event.BusinessDate }}</td>
                <td class="ala-ts">{{ event.Timestamp }}</td>
                <td>
                  <span class="ala-action-badge" [ngClass]="getBadgeClass(event.Action)">
                    {{ event.Action }}
                  </span>
                </td>
                <td>{{ event.ActorName }}</td>
                <td>{{ event.Shift }}</td>
                <td>{{ event.Job }}</td>
                <td [class]="getCreditClass(event)">{{ formatCurrency(event.Credit) }}</td>
                <td class="num">{{ formatCurrency(event.Debit) }}</td>
                <td>{{ formatSummary(event.Summary) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>
